import React, { lazy } from 'react';
import { EventAvailable as SchedulingIcon } from '@mui/icons-material';
import { MODULE_IDS } from '../../config/moduleConfig';
import adminPermissions from './permissions';

const SchedulingPage = lazy(() => import('./components/SchedulingPage'));

const schedulingModule = {
  id: MODULE_IDS.SCHEDULING,
  title: 'Scheduling',
  description: 'View shifts, request open shifts, and manage recurring coverage',
  path: '/scheduling',
  color: 'success.light',
  icon: <SchedulingIcon sx={{ fontSize: 48, color: 'success.main' }} />,
  navigation: {
    label: 'Scheduling',
    path: '/scheduling',
    icon: <SchedulingIcon />,
    available: true
  },
  routes: [
    {
      path: '/scheduling',
      element: <SchedulingPage />
    }
  ],
  adminPermissions
};

export default schedulingModule;
